// export const apiUrl = "http://localhost:8580/gallery/";

     // export const apiUrl = "https://sdmapi.holisol.in/gallery/";

    export const apiUrl = "https://holiboardapi.holisollogistics.com/gallery/";
